<template>
  <div class="body-width  div-top">
    <ul class="breadcrumb">
      <li  @mouseenter="handleEnter('/producthhwhyx/hhwhyxgkj')" @mouseleave="handleLeave('/producthhwhyx/hhwhyxgkj')" class="li-padding-left20">
        <a @click="setroters('/producthhwhyx/hhwhyxgkj')">
          <span :class="hhwhyxgkj===true?'font-Normal-1400':'font-Normal-14B6'">航海文化研学及沉浸式高科技体验系列产品</span>
        </a>
      </li>      
      <li  @mouseenter="handleEnter('/producthhwhyx/lssykp')" @mouseleave="handleLeave('/producthhwhyx/lssykp')">
        <a @click="setroters('/producthhwhyx/lssykp')">
          <span :class="lssykp===true?'font-Normal-1400':'font-Normal-14B6'">历史溯源科普</span>
        </a>
        
      </li>
      <li @mouseenter="handleEnter('/producthhwhyx/cjtytj')" @mouseleave="handleLeave('/producthhwhyx/cjtytj')">
        <a @click="setroters('/producthhwhyx/cjtytj')">
          <span :class="cjtytj===true?'font-Normal-1400':'font-Normal-14B6'">沉浸体验拓界</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/producthhwhyx/ipfn')" @mouseleave="handleLeave('/producthhwhyx/ipfn')">
        <a @click="setroters('/producthhwhyx/ipfn')">
          <span :class="ipfn===true?'font-Normal-1400':'font-Normal-14B6'">IP赋能</span>
        </a>
      </li>
    </ul>
  </div>

</template>
<script>
  export default {
    name: "hhxnsxxheader",
    data() {
      return {
        hhwhyxgkj: false,
        lssykp: false,
        cjtytj: false,
        ipfn: false,

        ishhwhyxgkj:false,
        islssykp:false,
        iscjtytj:false,
        isipfn:false,
      }
    },
    methods: {
      handleEnter(src) {
        if (src === '/producthhwhyx/hhwhyxgkj') {
          this.hhwhyxgkj = true
        }
        if (src === '/producthhwhyx/lssykp') {
          this.lssykp = true
        }
        if (src === '/producthhwhyx/cjtytj') {
          this.cjtytj = true
        }
        if (src === '/producthhwhyx/ipfn') {
          this.ipfn = true
        }
      },
      handleLeave(src) {
        if (src === '/producthhwhyx/hhwhyxgkj') {
          if(!this.ishhwhyxgkj){
            this.hhwhyxgkj = false
          }
        }
        if (src === '/producthhwhyx/lssykp') {
          if(!this.islssykp){
            this.lssykp = false
          }
        }
        if (src === '/producthhwhyx/cjtytj') {
          if(!this.iscjtytj){
            this.cjtytj = false
          }
        }
        if (src === '/producthhwhyx/ipfn') {
          if(!this.isipfn){
            this.ipfn = false
          }
        }
      },

      setroters(src) {
        if (src === '/producthhwhyx/hhwhyxgkj') {
          this.hhwhyxgkj = true
          this.ishhwhyxgkj = true
        } else {
          this.hhwhyxgkj = false
          this.ishhwhyxgkj = false
        }
        if (src === '/producthhwhyx/lssykp') {
          this.lssykp = true
          this.islssykp = true
        } else {
          this.lssykp = false
          this.islssykp = false
        }
        if (src === '/producthhwhyx/cjtytj') {
          this.cjtytj = true
          this.iscjtytj = true
        } else {
          this.cjtytj = false
          this.iscjtytj = false
        }
        if (src === '/producthhwhyx/ipfn') {
          this.ipfn = true
          this.isipfn = true
        } else {
          this.ipfn = false
          this.isipfn = false
        }
        this.$router.push(src);
      }
    },
    mounted() {
      this.setroters('/producthhwhyx/hhwhyxgkj');
    }
  }

</script>

<style scoped>
  .div-top {
    margin-top: 50px;
  }
.breadcrumb{
   background-color: #fbfbfb !important;
}
  .breadcrumb > li + li:before {
 
    color: #666666;
    content: "| ";
    padding: 0 16px;
  }
  .li-padding-left20 {
    padding-left: 20px;
  }

.font-Normal-1400,
.font-Normal-14B6 {
  font-size: 17px; /* 固定基础字号，两个class字号保持一致 */
  font-weight: 600;
  /* 新增缩放过渡，只做视觉变化，不改变布局 */
  transition: transform 0.2s ease;
  display: inline-block; /* transform生效必备 */
  transform-origin: center; /* 居中放大，避免单侧偏移拉扯 */
}

/* 选中态只用scale放大，不改字号 */
.font-Normal-1400 {
  transform: scale(1.1); /* 视觉放大效果，替代增大font-size */
}



</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hhwhyxlcp/hhwhyxheader.vue